<template>
<div>
    <v-card>
      <v-toolbar dense class="toolbar" height="35px" color="grey lighten-3">     
        <img class="img-icons" src="@/assets/list_icon.png" id="icon" alt="User Icon" />          
        <span >Additional Services </span>
        <v-spacer></v-spacer>
         <div class="md-toolbar-section-end">             
              <v-btn small style="margin-left:10px" @click="addService()">
                    <img class="img-icons" src="@/assets/add_icon.png"/>  ADD SERVICE
              </v-btn>
        </div>
      </v-toolbar>
       <ag-grid-vue style="width: 100%;"
                 class="ag-theme-balham"
                 domLayout="autoHeight"
                 :columnDefs="columnDefs"
                 :enableFillHandle="true"
                 :defaultColDef="defaultColDef"
                 :frameworkComponents="frameworkComponents"
                 :context="context"
                 @cell-value-changed="gridDataChanged"
                 :rowData="servicesData">
                </ag-grid-vue>
    </v-card>
    
</div>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import {AgGridVue} from "ag-grid-vue";
  import DeleteCell from "./DeleteCell.js";  
  import { mapState, mapActions } from 'vuex'
  
  export default {
    name: 'itinerary-detail-panel',
    computed: {
        ...mapState('invoice', ['selectedInvoice']),
    },
    
    mixins: [validationMixin],  
    components: {
            AgGridVue,            
        },
    beforeMount() {
        this.context = { componentParent: this };
    },
    data: () => ({            
      context: null,
      servicesData:[],
      columnDefs:[
          { headerName: 'Description', field:'description'},
          { headerName: 'Charges', field:'charges'},
          { field: "category",                
        cellEditor: 'agSelectCellEditor',                
        cellEditorParams: {            
            values: ['Other','Transportation','Accomodation']
        },
        editable: true
    },
          { headerName: "Action", field: "value", cellRenderer: "deleteCell", editable: false, colId: "deleteCell", width: 150 },
        ], 
        frameworkComponents:{deleteCell:DeleteCell},              
        defaultColDef: {
        flex: 1,
        editable: true
      },
      suppliers: [],
      gdsValues: []
    }),
    created () {
      // let self = this
    },
    watch: {
        selectedInvoice(newValue, oldValue) {      
            console.log(oldValue)
            if (newValue.services) {
              this.servicesData = JSON.parse(JSON.stringify(newValue.services))
            }
            else {
              this.servicesData=[]
            }
        }      
    },
    methods: {
      ...mapActions('invoice', ['updateServicesData']),
      gridDataChanged()  {
          let cloneServicesData=JSON.parse(JSON.stringify(this.servicesData))
          this.updateServicesData(cloneServicesData)
        },
       methodFromParent(rowIndex) {          
           this.servicesData.splice(rowIndex,1);
           this.gridDataChanged()
      },
        addService()  {
            this.servicesData.push({description:"",category:"Other",charges:0});
        },
    }
  }
</script>

<style lang="scss">
  .thead-container {
    height: auto !important;
    padding: 0px 0 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .td {
    height: 28px !important;
  }

</style>

<style scoped>
  .v-btn {
    margin: 0px 0;
    height:auto;
  }
  .img-icons {
    height: 24px;
  }
  .menu-logo {
    height: 20px;
  }
  .table-remove-icon {
    min-width: auto
  }
  .v-container {
    padding-top: 0px;
    padding-bottom: 0px !important;
  }
</style>  